var app = angular.module("leonardo");

var ForgotPasswordController = function($scope, $state, $http, NotificationService, AnalyticsService, FormErrorsService, $timeout, ConfigThemeService) {
  $scope.step = 1;

  $scope.returnHome = function() {
    $timeout(function () {
      $state.go('home');
    }, 100);
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var url = ConfigThemeService.generateURL('/api/2.0/forgot-password/');
    var uri = new URI(url);

    $http.post(uri.toString(), {email:$scope.email}).then(function(data) {
      AnalyticsService.track('Password Reset Initiated');
      data = data.data;
      if (data?.action === 'redirect') {
        window.location.replace(data?.url);
      }
      else {
        $scope.step = 2;
      }
    }).catch(function(){
      // This is intentional do_something blank function
    });
  };
};

app.controller('ForgotPasswordController', ['$scope', '$state', '$http', 'NotificationService', 'AnalyticsService', 'FormErrorsService',
  '$timeout', 'ConfigThemeService', ForgotPasswordController]);
